"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastModifiedKeys = void 0;
var LastModifiedKeys;
(function (LastModifiedKeys) {
    /**
     * Is this flag is passed, only return default values, no overridden values.
     */
    LastModifiedKeys["DEFAULTS_ONLY"] = "0";
    /**
     * If this flag is passed, don't cache any overridden values, but fetch them on each request.
     */
    LastModifiedKeys["BYPASS_OVERRIDE_CACHE"] = "00";
    /**
     * If this flag is passed, use last modified date from the cached response.
     */
    LastModifiedKeys["USE_CACHED"] = "000";
})(LastModifiedKeys || (exports.LastModifiedKeys = LastModifiedKeys = {}));
//# sourceMappingURL=index.js.map